import { createRequestHelper } from '@utils/swr'
import { type CampaignMemberErrorResponse } from '../types/apiErrorResponse'
import { type CampaignMemberRequest } from '../types/apiRequest'
import { type CampaignMemberResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

const {
  useRequest,
  getSwrFetcher,
} = createRequestHelper<FortuneApis['get']['campaignMember'], CampaignMemberResponse, CampaignMemberRequest, CampaignMemberErrorResponse>({
  client: 'fortune',
  key: params => params?.code ? `/campaigns/${params?.code}/member` : null,
  isImmutable: true,
})

export const useApiCampaignMember = useRequest
export const getCampaignMemberFetcher = getSwrFetcher
